<template>
  <div class="unit-curve w-full h-full">
    <div class="chart-unit">
      <v-chart
        v-if="showChart"
        ref="unitCurve"
        :options="options"
        :autoresize="true"
        class="!h-full !w-full"
      />
    </div>
  </div>
</template>
<script>
import Echarts from 'vue-echarts/components/ECharts'
import $echarts from 'echarts'
import _ from 'lodash'
import 'echarts/theme/macarons'

export default {
  name: 'unitCurve',
  components: {
    'v-chart': Echarts,
  },
  props: {
    dateType: {
      type: String,
      default: [],
    },
    unitCurveList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      showChart: true,
      currUnitName: '',
      activeUnit: 0,
      options: {
        grid: {
          top: '35%',
          left: '4%',
          right: '3%',
          bottom: '0%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          left: 'center',
          top: 0,
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 15,
          borderRadius: 4,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        xAxis: {
          type: 'category',
          data: [''],
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: 'rgba(255,255,255,0.8)', // X轴文字颜色
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '（人）',
            nameGap: 20, // x轴name与横坐标轴线的间距
            nameLocation: 'end', // x轴name处于x轴的什么位置
            nameTextStyle: {
              color: 'rgba(255,255,255,0.8)',
              fontSize: 14,
              padding: [0, 0, 0, -45], // 四个数字分别为上右下左与原位置距离
            },
            nameGap: 20, // 表现为上下位置
            minInterval: 1,
            axisLine: {
              show: false,
              lineStyle: {
                color: '#eeeeee',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: 'rgba(255,255,255,0.8)', // y轴文字颜色
              fontSize: 12,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)',
              },
            },
          },
        ],
        series: [],
      },
      allData: [],
    }
  },
  computed: {
    unitList() {
      return this.allData.map((it) => { return it.name })
    },
  },
  watch: {
    unitCurveList: {
      handler(val) {
        this.allData = _.cloneDeep(val)
        // this.allData.forEach((it) => {
        //   if (!it.deptId && it.id !== 'QT') {
        //     it.name = '全部'
        //   }
        // })
        this.handleOptions(this.allData)
      },
      deep: true,
    },
  },
  created() {
    this.handleOptions(this.unitCurveList)
  },
  methods: {
    unitTab(index, it) {
      this.activeUnit = index
      this.currUnitName = it
      const data = this.allData.find((item) => { return item.name === it })
      this.options.series[0].data = data.data.map((it) => { return it.yValue })
      this.options.series[1].data = data.data.map((it) => { return it.yValue1 })
    },
    handleOptions(val) {
      if (val && val.length) {
        this.showChart = true
        if (this.dateType === '当日') {
          this.options.xAxis.data = val[0].data.map((it) => {
            return it.xValue
          })
        } else if (this.dateType === '本周') {
          this.options.xAxis.data = val[0].data.map((it) => {
            return it.xValue
          })
        } else if ('本月') {
          this.options.xAxis.data = val[0].data.map((it) => {
            return it.xValue
          })
        }
        const colorList = [
          '#007E82',
          '#EFEF91',
          '#824E00',
          '#824E00',
          '#6ECBFF',
          '#c12e34',
          '#e6b600',
          '#0098d9',
          '#2b821d',
          '#005eaa',
          '#339ca8',
          '#cda819',
          '#32a487',
          '#00FF7F',
          '#4682B4',
          '#D2B48C',
          '#008080',
          '#D8BFD8',
          '#FF6347',
          '#40E0D0',
          '#EE82EE',
        ]
        this.options.series = _.map(val, (item, index) => {
          console.log(index, colorList[index])
          return {
            name: item.name,
            type: 'line',
            // showAllSymbol: true, //显示所有图形。
            symbol: 'circle', // 标记的图形为实心圆
            symbolSize: 5, // 标记的大小
            itemStyle: {
              // 折线拐点标志的样式
              color: colorList[index] || '#2ec7c9',
              borderWidth: '1',
              borderColor: '#fff',
            },
            lineStyle: {
              color: colorList[index] || '#2ec7c9',
            },
            data: _.map(item.data, 'yValue'),
          }
        })
        this.options = this.options
        // const unit = this.currUnitName ? this.currUnitName : val[0].name;
        // this.unitTab(this.activeUnit, unit);
      } else {
        this.showChart = false
        this.options = this.$options.data().options
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.unit-curve {
  position: relative;
  .unit-box {
    color: #fff;
    position: absolute;
    top: -10px;
    width: 100%;
    text-align: center;
    .unit-item {
      padding: 5px;
      margin-left: 15px;
      cursor: pointer;
      position: relative;
      &::before {
        content: '';
        width: 10px;
        height: 10px;
        border: 1px solid #fff;
        display: inline-block;
        border-radius: 50%;
      }
    }
    .all::before {
      position: absolute;
      width: 14px;
      height: 14px;
      top: 5px;
      left: -14px;
    }
    .is-active-unit::before {
      background: #007e82;
      border: none;
    }
  }
  .chart-unit {
    height: 100%;
  }
}
</style>
